/* tslint:disable:completed-docs */
import { Injectable } from '@angular/core';
import { StorageService } from '../base/storage.service';

@Injectable()
export class StorageServiceController {
  constructor(protected storage: StorageService) {}

  getStorage(): StorageService {
    return this.storage;
  }
}
